import { Box, BoxProps } from "@mantine/core";
import { CSSProperties, ElementType, ReactNode } from "react";
import { SpacingPxs, pxToRem } from "theme";

export type FlexProps = BoxProps<any> & {
  children: ReactNode;
  direction?: CSSProperties["flexDirection"];
  /**
   * Is a PX number that is converted to REM
   * @see {@link ./src/theme/spacing.ts}
   */
  gap?: SpacingPxs;
  align?: CSSProperties["alignItems"];
  justify?: CSSProperties["justifyContent"];
  flex?: CSSProperties["flex"];
  style?: CSSProperties;
  as?: ElementType;
};

export const Flex = ({
  children,
  direction = "column",
  gap,
  style,
  justify,
  align,
  flex,
  as,
  ...boxProps
}: FlexProps) => (
  <Box
    style={{
      display: "flex",
      flexDirection: direction,
      gap: gap ? pxToRem[gap] : undefined,
      flex,
      justifyContent: justify,
      alignItems: align,
      ...style,
    }}
    component={as}
    {...boxProps}
  >
    {children}
  </Box>
);
